"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import useFetchPosts from "@/components/post/fetcher";
import { useLocale } from "next-intl";
import Letstalk from "../header/LetsTalkB";
export default function BlogSection() {


   const l = useLocale();
  const router = useRouter(); // Initialize the router
  const { posts, error, isLoading } = useFetchPosts();

  const getLocalizedField = (item: any, field: string) => item[`${field}_${l}`] || item[`${field}_en`];

 

  return (
    <div className="p-4 lg:p-24 bg-white">
      <div className="flex justify-between gap-2 flex-wrap items-center  ">
        <h2 className="text-4xl mt-8 lg:mt-0 lg:text-6xl  2xl:text-7xl font-bold">Digital Trends</h2>
        <Letstalk/>
      </div>

      <div className="grid grid-cols-1  md:grid-cols-3 gap-6 lg:gap-16 mt-12 mb-12 lg:mb-0">
        {posts.slice(0,3).map((post, i) => (
          <div key={i} className="group space-y-4 cursor-pointer">
            <div 
            onClick={() => router.push(`/blog/${getLocalizedField(post, 'url')}`)}
            className="relative w-full h-80 md:h-60 lg:h-[420px] rounded-3xl overflow-hidden shadow-lg transition-all duration-500 ease-out group-hover:shadow-2xl group-hover:-translate-y-2">
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(post, "image")}`}
                alt="padel-book-alt"
                quality={100}
                fill
                sizes="50vw"
                className="object-cover rounded-3xl transition-transform duration-700 ease-out group-hover:scale-110"
                priority
              />

              {/* Gradient overlay that fades in on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* Arrow badge that pops in on hover */}
              <div className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-100">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7 17L17 7" />
                  <path d="M7 7h10v10" />
                </svg>
              </div>
            </div>

            <h4
            onClick={() => router.push(`/blog/${getLocalizedField(post, 'url')}`)}
            className="text-xl lg:text-3xl font-bold transition-colors duration-300 group-hover:text-primary">
              {getLocalizedField(post, "title")}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
}